import { all, call, put, fork, takeEvery, select } from 'redux-saga/effects';
import { fetchSurveyGroupsSuccess, showSurveyGroupMessage, onSaveSurveyGroupSuccess } from 'actions/SurveyGroup';
import { ON_SAVE_SURVEY_GROUP, FETCH_ALL_SURVEY_GROUP } from 'constants/ActionTypes';
import { update, post } from 'services/ApiClient';
import { endpoint } from 'services/ApiConfig';
import { fetchDataRequest } from 'services/ApiService';

const fetchSurveyGroupsRequest = async () => {
    return fetchDataRequest('surveyGroups');
};

function* fetchSurveyGroups() {
    try {
        const fetchedSurveyGroups = yield call(fetchSurveyGroupsRequest) || [];
        yield put(fetchSurveyGroupsSuccess(fetchedSurveyGroups));
    } catch (error) {
        yield put(showSurveyGroupMessage(error.messages));
    }
}

const getSurveyGroupList = (state) => state.surveyGroups.surveyGroupList;

function* saveSurveyGroup({ payload }) {
    try {
        const allSurveyGroups = yield select(getSurveyGroupList);
        const savedSurveyGroups = yield call(saveSurveyGroupRequest, allSurveyGroups, payload);
        yield put(onSaveSurveyGroupSuccess(savedSurveyGroups));
    } catch (error) {
        yield put(showSurveyGroupMessage(error.messages));
    }
}

const saveSurveyGroupRequest = async (allSurveyGroups, payload) => {
    try {
        let isNew = true;
        const surveyGroupList = allSurveyGroups.map((surveyGroup) => {
            if (surveyGroup.id === payload.id) {
                isNew = false;
                return payload;
            } else {
                return surveyGroup;
            }
        });

        const endpointConfig = isNew ? endpoint('addSurveyGroup') : endpoint('updateSurveyGroup');
        if (isNew) {
            // eslint-disable-next-line no-unused-vars
            if (endpointConfig) {
                await post(endpointConfig.uri, payload)
                    .then((response) => {
                        // the response will return the id so place it back into the local object
                        const id = response ? response.id : 'addSurveyGroupResponseError';
                        const updatedPayload = { ...payload, id: id };
                        surveyGroupList.push(updatedPayload);
                    })
                    .catch(error => {
                        throw error;
                    });
            }
        } else {
            if (endpointConfig) {
                // TODO add audit messages
                await update(endpointConfig.uri, payload)
                    .then(payload => payload) // already in list
                    .catch(error => {
                        throw error;
                    });
            }
        }
        return surveyGroupList;
    } catch (error) {
        throw error;
    }
};

export function* fetchSurveyGroupsSaga() {
    yield takeEvery(FETCH_ALL_SURVEY_GROUP, fetchSurveyGroups);
}

export function* saveSurveyGroupSaga() {
    yield takeEvery(ON_SAVE_SURVEY_GROUP, saveSurveyGroup);
}

export default function* rootSaga() {
    yield all([fork(fetchSurveyGroupsSaga), fork(saveSurveyGroupSaga)]);
}


// WEBPACK FOOTER //
// ./sagas/SurveyGroup.js